import { render } from "./resultados-finais.vue?vue&type=template&id=be4d796c&scoped=true"
import script from "./resultados-finais.vue?vue&type=script&lang=js"
export * from "./resultados-finais.vue?vue&type=script&lang=js"

import "./resultados-finais.vue?vue&type=style&index=0&id=be4d796c&scoped=true&lang=css"
import "./resultados-finais.vue?vue&type=style&index=1&id=be4d796c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be4d796c"]])

export default __exports__